/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Prev_DocumentInputs */

const en_playbar_prev_document = /** @type {(inputs: Playbar_Prev_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Document`)
};

const es_playbar_prev_document = /** @type {(inputs: Playbar_Prev_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento anterior`)
};

/**
* | output |
* | --- |
* | "Previous Document" |
*
* @param {Playbar_Prev_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_prev_document = /** @type {((inputs?: Playbar_Prev_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Prev_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_prev_document(inputs)
	return en_playbar_prev_document(inputs)
});